import { paymentStatusesInfo, refundStatusesInfo } from '@reveni-io/reveni-ui'

import { scenarioOperationResultStatuses } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/hooks/useCustomScenario/constants'

const getOperationResultLabel = statuses => {
  if (statuses.refund_status) return refundStatusesInfo[statuses.refund_status].label

  return paymentStatusesInfo[statuses.payment_status].label
}

export const getOperationResultOptions = t => {
  return Object.entries(scenarioOperationResultStatuses).map(([value, statuses]) => {
    return { value, label: t(getOperationResultLabel(statuses)) }
  })
}
